export default __webpack_public_path__ + "static/media/information--minimum-speed-60--g1.212570f9.png";